import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import type { SessionUser } from "@app/shared";
import { api } from "./api";
import { useToast } from "../components/Toast";

/**
 * The current session user from the cached `["me"]` query. The layout routes
 * render only after `ProtectedRoute` has resolved it, so this is non-null there.
 */
export function useSessionUser(): SessionUser {
  const { data } = useQuery({
    queryKey: ["me"],
    queryFn: ({ signal }) => api.me(signal),
    staleTime: 60_000,
  });
  return data as SessionUser;
}

/** Logout mutation: clears the cache and returns to /login. */
export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: () => api.logout(),
    onSuccess: () => {
      queryClient.clear();
      navigate("/login", { replace: true });
    },
    onError: () => toast.error("Logout failed"),
  });
}
